import { useEffect, useState } from "react";
import moment from "moment-timezone";
import {
  Grid,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ListItemButton,
  Typography,
  Box,
  Divider,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import convertLabel from "../../../utilities/convertLabel";
import request from "../../../utilities/requests";
const userTimezone = moment.tz.guess();

const CommLog = ({ user }) => {
  const [logs, setLogs] = useState([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const getLogs = async () => {
    const body = {
      data: {
        user: user._id,
      },
    };
    const result = await request("communications/commlog", "post", body);
    if (result.success) {
      setLogs(result.data);
    }
  };

  useEffect(() => {
    if (user) getLogs();
  }, [user]);

  return (
    <Grid item xs={12}>
      <Paper height={3}>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <ListItemButton style={{ fontWeight: "bold" }}>
              Communications Log
            </ListItemButton>
          </AccordionSummary>

          <AccordionDetails>
            {isMobile ? (
              <Box>
                {logs.map((item) => (
                  <Box key={item._id} sx={{ mb: 2 }}>
                    <Typography component="div">
                      <strong>Type:</strong> {convertLabel(item.template)}
                    </Typography>
                    <Typography component="div">
                      <strong>Sent:</strong>{" "}
                      {moment
                        .tz(item.createdAt, userTimezone)
                        .format("MMM D YYYY [@] h:mm")}
                    </Typography>
                    <Typography component="div">
                      <strong>Address:</strong> {item.address}
                    </Typography>
                    <Typography component="div">
                      <strong>Read At:</strong>{" "}
                      {item.readAt
                        ? moment
                            .tz(item.readAt, userTimezone)
                            .format("MMM D YYYY [@] h:mm")
                        : "-"}
                    </Typography>
                    <Divider sx={{ my: 1 }} />
                  </Box>
                ))}
              </Box>
            ) : (
              <Grid container spacing={1}>
                <Grid item xs={2}>
                  <Typography sx={{ fontWeight: "bold" }}>Type</Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ fontWeight: "bold" }}>Sent</Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ fontWeight: "bold" }}>Address</Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ fontWeight: "bold" }}>Read At</Typography>
                </Grid>
                {logs.map((item) => (
                  <Grid item xs={12} key={item._id}>
                    <Grid container spacing={3}>
                      <Grid item xs={2}>
                        <Typography variant="caption">
                          {convertLabel(item.template)}
                        </Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography variant="caption">
                          {moment
                            .tz(item.createdAt, userTimezone)
                            .format("MMM D YYYY [@] h:mm")}
                        </Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography variant="caption">
                          {item.address}
                        </Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography variant="caption">
                          {item.readAt
                            ? moment
                                .tz(item.readAt, userTimezone)
                                .format("MMM D YYYY [@] h:mm")
                            : ""}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            )}
          </AccordionDetails>
        </Accordion>
      </Paper>
    </Grid>
  );
};

export default CommLog;
